import { render, staticRenderFns } from "./pre-made-messages-popup.vue?vue&type=template&id=13dc71b3&scoped=true&"
import script from "./pre-made-messages-popup.vue?vue&type=script&lang=js&"
export * from "./pre-made-messages-popup.vue?vue&type=script&lang=js&"
import style0 from "./pre-made-messages-popup.vue?vue&type=style&index=0&id=13dc71b3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dc71b3",
  null
  
)

export default component.exports